Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.SocialContentAttachmentsView extends Backbone.View
  template: JST["backbone/templates/monitoring/social_contents_v2/social_content_attachments"]
  className: 'sc-attachments attachments-scrollable'

  initialize: (options = {}) ->
    @links = options.links or []
    @emailFiles = options.emailFiles or []
    @facebookAttachments = options.facebookAttachments or {}
    @webchatAttachments = options.webchatAttachments or {}
    @instagramStories = options.instagramStories or []
    @instagramStoriesAreExpired = options.instagramStoriesAreExpired
    @instagramAttachments = options.instagramAttachments or []
    @useVideoIcon = options.useVideoIcon or false

  render: ->
    @$el.html @template {
      @links,
      @emailFiles,
      @facebookAttachments,
      @webchatAttachments,
      @instagramStories,
      @instagramStoriesAreExpired,
      @instagramAttachments,
      @useVideoIcon
    }
    @$el.find('.sc-attachments-title').prepend(@_attachmentIcon().render().el)
    @$el.find('.sc-video-preview').magnificPopup(type: 'iframe', closeOnContentClick: true)
    @$el.find('.sc-picture-preview').magnificPopup(type: 'image', closeOnContentClick: true)
    @

  _attachmentIcon: ->
    if @useVideoIcon then @_videoIcon() else @_clipIcon()

  _videoIcon: ->
    new Common.SvgIconView(
      svgPath: 'icons/video-outline.svg'
      svgId: 'video-outline'
      iconClass: 'video-outline-icon'
    )

  _clipIcon: ->
    new Common.SvgIconView(
      svgPath: 'icon-attachment.svg'
      svgId: 'icon-attachment'
      iconClass: 'icon'
    )
